import {OperatorCalculationSettingsResponse} from "../../repository/api/generated/callApi";

export class Settings {

    private readonly denominator: number;
    private readonly numerator: number;
    private readonly excluded_statuses: string[];

    constructor(arg: OperatorCalculationSettingsResponse) {
        this.denominator = arg.denominator ?? 0;
        this.numerator = arg.numerator ?? 0;
        this.excluded_statuses = arg.excluded_statuses ?? [];
    }

    
    public Denominator = (): number => {
        return this.denominator
    }
    public Numerator = (): number => {
        return this.numerator
    }
    public ExcludeStatuses = (): string[] => {
        return this.excluded_statuses
    }
}